import { render } from "./VirtualKeyboard.vue?vue&type=template&id=032e1488"
import script from "./VirtualKeyboard.vue?vue&type=script&lang=js"
export * from "./VirtualKeyboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__